const agreeCheck = document.getElementById('agreeCheck');
const goForm = document.getElementById('goForm');

if (agreeCheck && goForm) {
  const goFormButtons = goForm.querySelectorAll('button');

  // 初期化（load待ち不要）
  agreeCheck.checked = false;
  goFormButtons.forEach((b) => (b.disabled = true));

  agreeCheck.addEventListener('change', function () {
    const enabled = this.checked;
    goFormButtons.forEach((b) => (b.disabled = !enabled));
  });
}


// 遷移
document.addEventListener('click', (e) => {
  const button = e.target.closest('#goForm button[data-href]');
  if (!button) return;
  if (button.disabled) return;

  const url = button.dataset.href;
  if (!url) return;

  window.location.href = url;
});


//modal
if (document.querySelector('button[data-micromodal-trigger]')) {
  MicroModal.init({
    disableScroll: true,
    disableFocus: true
  });
}
